<template>
  <div class="g-content">
    <!-- 搜索 -->
    <div class="g-content-filter">
      <div class="g-content-filter-main">
        <h3>{{ $t('blacklist_title') }}</h3>

        <div class="g-content-filter-right">
          <a-form-model :model="searchForm" layout="inline" ref="formElement">
            <!-- 关键字 -->
            <a-form-model-item :label="null" prop="sn">
              <a-input-search
                v-model="searchForm.sn"
                style="min-width:200px"
                :placeholder="$t('com_form_keyword_input')"
                allowClear
                @search="getList()"
              />
            </a-form-model-item>

            <!-- 提交 -->
            <a-form-model-item style="margin:0">
              <a-button type="primary" @click.prevent="getList()">
                {{ $t('com_btn_search') }}
              </a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
      </div>
    </div>

    <div class="g-content-main common-filter-main">
      <div class="black-content">
        <Loading :show="true" v-if="loading" />
        <NetworkError v-else-if="networkError" />
        <div class="g-table" v-else>
          <a-table
            :columns="columns"
            :data-source="list"
            bordered
            rowKey="id"
            :pagination="false"
            :loading="tableLoading"
            size="small"
          >
            <!-- 注册时间  -->
            <template slot="registerTime" slot-scope="text">
              {{ text | formatDate }}
            </template>

            <!-- 操作栏 -->
            <template slot="operation" slot-scope="text, record">
              <a-button
                type="danger"
                @click="remove(record)"
                icon="delete"
                v-auth="['auth_black_deviceDelete']"
                size="small"
              >
                {{ $t('com_btn_delete') }}
              </a-button>

              <router-link :to="`/manage/device/add/${record.devSn}`" v-auth="['auth_device_add']">
                <a-button type="primary" icon="plus" size="small">
                  {{ $t('blacklist_btn_add_device') }}
                </a-button>
              </router-link>
            </template>
          </a-table>

          <!-- 分页，大于1页才显示 -->
          <Pagination
            :current="pagination.current"
            :total="pagination.total"
            :pageSize.sync="pagination.pageSize"
            :callback="getList"
            @change="getList"
            v-if="pagination.total > 0"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as API from '@/api/device';
import { mapGetters } from 'vuex';

export default {
  components: {},

  data() {
    return {
      networkError: false,
      loading: true,
      tableLoading: false,
      // 搜索
      searchForm: {
        sn: '',
      },

      // 列表
      list: [],
      columns: [
        {
          title: '#',
          align: 'center',
          width: 80,
          customRender: (text, record, index) => {
            return (this.pagination.current - 1) * this.pagination.pageSize + (index + 1);
          },
        },
        {
          title: this.$t('blacklist_table_sn'),
          dataIndex: 'devSn',
          scopedSlots: { customRender: 'sn' },
        },

        {
          title: this.$t('blacklist_table_mac'),
          dataIndex: 'devMac',
          scopedSlots: { customRender: 'sn' },
        },

        {
          title: this.$t('blacklist_table_protocol_version'),
          dataIndex: 'protoVer',
          scopedSlots: { customRender: 'sn' },
        },

        {
          title: this.$t('blacklist_table_register_time'),
          dataIndex: 'registerTime',
          scopedSlots: { customRender: 'registerTime' },
        },
      ],

      // 分页
      pagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 20,
        // 记录总条数
        total: 0,
      },
    };
  },

  computed: {
    ...mapGetters(['authList', 'isSuperAdmin']),
  },

  created() {
    // 操作
    if (
      this.authList.includes('auth_device_add') ||
      this.authList.includes('auth_black_deviceDelete') ||
      this.isSuperAdmin
    ) {
      this.columns.push({
        title: this.$t('user_operation'),
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' },
      });
    }

    this.getList();
  },
  methods: {
    getList(pageNo) {
      this.pagination.current = pageNo || 1;
      const params = {
        ...this.searchForm,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
      };
      this.tableLoading = true;
      this.networkError = false;

      API.DeviceBlackList(params)
        .then(res => {
          if (res.code === 0) {
            this.loadSuccess(res);
          }
        })
        .catch(err => {
          if (!/cancelled/gi.test(err)) {
            this.networkError = true;
          }
        })
        .finally(() => {
          this.loadComplete();
        });
    },

    loadComplete() {
      this.$store.commit('setPageLoading', false);
      this.loading = false;
      this.tableLoading = false;
    },

    // 成功
    loadSuccess(res) {
      this.list = res.data || [];

      // total
      this.pagination.total = res.totalCount;
    },

    // 删除
    remove(record) {
      this.$confirm({
        title: this.$t('blacklist_confirm_delete_title'),
        content: '',
        onOk: () => {
          this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));
          API.DeviceBlackListDelete({ id: record.id })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_delete_success'));
                this.getList();
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
        onCancel() {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
.logs-nav {
  a {
    margin-right: 15px;
    color: #666;
    font-size: 12px;

    &.router-link-active {
      color: #1838d9;
      font-weight: bold;
    }
  }
}
</style>
